import React, { useState, useEffect } from 'react';

const EditableColumnHeader = ({ headerKey, value, setColumnHeaders }) => {
  const [localText, setLocalText] = useState(value);
  const [isEditing, setIsEditing] = useState(false);
  
  // Update local text when value changes from outside
  useEffect(() => {
    if (!isEditing) {
      setLocalText(value);
    }
  }, [value, isEditing]);
  
  const startEditing = () => {
    setIsEditing(true);
    setLocalText(value);
  };
  
  const finishEditing = () => {
    setColumnHeaders(prev => ({
      ...prev,
      [headerKey]: localText
    }));
    setIsEditing(false);
  };
  
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      finishEditing();
    } else if (e.key === 'Escape') {
      setLocalText(value); // Reset to original value
      setIsEditing(false);
    }
  };

  return (
    <div className="w-full h-8 flex items-center">
      {isEditing ? (
        <input
          className="w-full h-8 px-0 text-xl text-gray-500 bg-white border rounded"
          value={localText}
          onChange={(e) => setLocalText(e.target.value)}
          onBlur={finishEditing}
          onKeyDown={handleKeyPress}
          autoFocus
        />
      ) : (
        <h2 
          className="text-xl text-gray-500 cursor-pointer h-8 flex items-center"
          onDoubleClick={startEditing}
        >
          {value}
        </h2>
      )}
    </div>
  );
};

export default EditableColumnHeader; 